// 샘플(예시) 이벤트 데이터 - 이벤트 페이지(EventsPage) 및 관리자 페이지(AdminEventsPage)에서 공통 사용
// id 충돌을 피하기 위해 문자열 prefix `sample-` 사용

export const sampleEvents = [
  {
    id: "sample-1",
    category: "offline",
    subcategory: "4050",
    title: "4050 봄맞이 와인 모임",
    description: "봄을 맞이하여 40-50대 싱글분들을 위한 와인 테이스팅 모임입니다. 소믈리에가 엄선한 와인과 함께 즐거운 대화를 나눠보세요.",
    date: "2026-04-12",
    time: "19:00",
    location: "서울 강남구 청담동",
    venue: "와인바 '라뷰'",
    price: 80000,
    capacity: 20,
    registered: 14,
    image: "https://images.unsplash.com/photo-1510812431401-41d2bd2722f3?w=600",
    highlights: ["소믈리에 진행", "프리미엄 와인 5종", "핑거푸드 제공"],
    isPopular: true,
  },
  {
    id: "sample-2",
    category: "offline",
    subcategory: "5060",
    title: "5060 주말 브런치 모임",
    description: "50-60대 싱글분들을 위한 품격있는 주말 브런치 모임. 호텔 레스토랑에서 여유로운 대화와 함께 즐거운 시간을 보내세요.",
    date: "2026-04-19",
    time: "11:30",
    location: "서울 중구 소공동",
    venue: "웨스틴조선호텔",
    price: 95000,
    capacity: 16,
    registered: 10,
    image: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=600",
    highlights: ["호텔 브런치 코스", "프로 MC 진행", "1:1 매칭 시간"],
    isPopular: false,
  },
  {
    id: "sample-3",
    category: "small",
    subcategory: "취미별",
    title: "골프 동호회 모임",
    description: "골프를 사랑하는 싱글분들의 라운딩 모임입니다. 18홀 라운딩 후 저녁 식사까지 함께합니다.",
    date: "2026-04-26",
    time: "07:00",
    location: "경기도 용인시",
    venue: "레이크사이드 CC",
    price: 250000,
    capacity: 12,
    registered: 8,
    image: "https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=600",
    highlights: ["18홀 라운딩", "그린피 포함", "저녁 식사"],
    isPopular: true,
  },
  {
    id: "sample-4",
    category: "small",
    subcategory: "지역별",
    title: "부산 해운대 산책 모임",
    description: "부산 해운대에서 함께 바닷바람을 맞으며 산책하고, 맛있는 해산물 요리를 즐기는 모임입니다.",
    date: "2026-05-03",
    time: "14:00",
    location: "부산 해운대구",
    venue: "해운대 해변",
    price: 45000,
    capacity: 10,
    registered: 6,
    image: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=600",
    highlights: ["해변 산책", "해산물 저녁", "카페 타임"],
    isPopular: false,
  },
  {
    id: "sample-5",
    category: "party",
    subcategory: "발렌타인 데이",
    title: "발렌타인 데이 스페셜 파티",
    description: "발렌타인 데이를 맞아 특별하게 준비한 로맨틱 파티입니다. 초콜릿 만들기, 칵테일, 라이브 음악이 함께합니다.",
    date: "2026-02-14",
    time: "18:00",
    location: "서울 마포구 홍대",
    venue: "클럽 '로맨스'",
    price: 120000,
    capacity: 40,
    registered: 35,
    image: "https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=600",
    highlights: ["초콜릿 만들기", "라이브 밴드", "칵테일 무제한"],
    isPopular: true,
  },
  {
    id: "sample-6",
    category: "party",
    subcategory: "연말 송년회",
    title: "2026 송년의 밤 파티",
    description: "한 해를 마무리하며 새로운 인연을 만나는 송년 파티입니다. 뷔페, 공연, 경품 추첨이 함께합니다.",
    date: "2026-12-28",
    time: "19:00",
    location: "서울 강남구 역삼동",
    venue: "그랜드 볼룸",
    price: 150000,
    capacity: 100,
    registered: 45,
    image: "https://images.unsplash.com/photo-1496843916299-590492c751f4?w=600",
    highlights: ["프리미엄 뷔페", "라이브 공연", "경품 추첨"],
    isPopular: false,
  },
  {
    id: "sample-7",
    category: "camp",
    subcategory: "힐링캠프",
    title: "제주 힐링 캠프 2박 3일",
    description: "제주의 아름다운 자연 속에서 힐링하며 새로운 인연을 만나는 특별한 캠프입니다.",
    date: "2026-05-15",
    time: "10:00",
    location: "제주도 서귀포시",
    venue: "제주 힐링 리조트",
    price: 450000,
    capacity: 24,
    registered: 18,
    image: "https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=600",
    highlights: ["2박 3일 숙박", "올레길 트레킹", "바베큐 파티"],
    isPopular: true,
  },
  {
    id: "sample-8",
    category: "camp",
    subcategory: "1박 캠프",
    title: "가평 글램핑 1박 2일",
    description: "가평의 자연 속에서 럭셔리 글램핑을 즐기며 특별한 만남을 가지는 1박 2일 캠프입니다.",
    date: "2026-06-07",
    time: "15:00",
    location: "경기도 가평군",
    venue: "가평 글램핑 빌리지",
    price: 280000,
    capacity: 16,
    registered: 12,
    image: "https://images.unsplash.com/photo-1504280390367-361c6d9f38f4?w=600",
    highlights: ["럭셔리 글램핑", "캠프파이어", "조식 제공"],
    isPopular: false,
  },
];

// 관리자 페이지 테이블 형식에 맞게 변환 (type=offline, currentParticipants, maxParticipants 등)
export const sampleEventsForAdmin = sampleEvents.map((e) => ({
  id: e.id,
  title: e.title,
  description: e.description,
  type: "offline",
  date: e.date,
  time: e.time,
  location: `${e.location} · ${e.venue}`,
  price: e.price,
  maxParticipants: e.capacity,
  currentParticipants: e.registered,
  status: "upcoming",
  noticeCategories: ["all"],
  image: e.image,
  timezone: "Asia/Seoul",
  currency: "KRW",
  isSample: true,
}));
